import {
  ModuleCategory,
  SchemaTypeHelper,
  SingleUnion,
  SubscribesTo,
  createComponentAdmin,
  scrollToDescription,
} from '@backstage-components/base';
import {Type} from '@sinclair/typebox';

export const reactName = 'Container';
export const name = reactName;
export const description = reactName;
const category: ModuleCategory = 'layout';

const instructions = SingleUnion(
  SubscribesTo({
    topic: `${reactName}:scrollTo`,
    description: scrollToDescription,
    meta: {
      scrollX: Type.Optional(Type.String()),
      scrollY: Type.Optional(Type.String()),
      anchorElId: Type.Optional(Type.String()),
      elementId: Type.Optional(Type.String()),
    },
  })
);

export const ComponentDefinition = createComponentAdmin({
  id: '9b365e21-e2fe-4164-8c05-851342f644fe',
  reactName,
  name,
  slug: reactName,
  description,
  version: 1,
  defaultFieldData: {},
  slotConfiguration: {
    items: {maxModules: 100, displayWidth: 12, title: 'Modules'},
  },
  schema: Type.Object({}),
  uiSchema: {},
  instructions,
  category,
})
  .withAnimationStates()
  .withStyles()
  .build();

export type SchemaType = SchemaTypeHelper<typeof ComponentDefinition>;
